/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidationSummaryDto
 */
export interface ValidationSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof ValidationSummaryDto
     */
    totalRows?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationSummaryDto
     */
    validRows?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationSummaryDto
     */
    errorRows?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationSummaryDto
     */
    warningRows?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationSummaryDto
     */
    skippedRows?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationSummaryDto
     */
    correctedRows?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ValidationSummaryDto
     */
    errorsByCode?: { [key: string]: number; } | null;
}

/**
 * Check if a given object implements the ValidationSummaryDto interface.
 */
export function instanceOfValidationSummaryDto(value: object): value is ValidationSummaryDto {
    return true;
}

export function ValidationSummaryDtoFromJSON(json: any): ValidationSummaryDto {
    return ValidationSummaryDtoFromJSONTyped(json, false);
}

export function ValidationSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRows': json['totalRows'] == null ? undefined : json['totalRows'],
        'validRows': json['validRows'] == null ? undefined : json['validRows'],
        'errorRows': json['errorRows'] == null ? undefined : json['errorRows'],
        'warningRows': json['warningRows'] == null ? undefined : json['warningRows'],
        'skippedRows': json['skippedRows'] == null ? undefined : json['skippedRows'],
        'correctedRows': json['correctedRows'] == null ? undefined : json['correctedRows'],
        'errorsByCode': json['errorsByCode'] == null ? undefined : json['errorsByCode'],
    };
}

export function ValidationSummaryDtoToJSON(json: any): ValidationSummaryDto {
    return ValidationSummaryDtoToJSONTyped(json, false);
}

export function ValidationSummaryDtoToJSONTyped(value?: ValidationSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalRows': value['totalRows'],
        'validRows': value['validRows'],
        'errorRows': value['errorRows'],
        'warningRows': value['warningRows'],
        'skippedRows': value['skippedRows'],
        'correctedRows': value['correctedRows'],
        'errorsByCode': value['errorsByCode'],
    };
}

